module.exports = __webpack_public_path__ + "static/img/s503.261f0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s503.png
// module id = 565
// module chunks = 3